"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorImportReport = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const routes_1 = require("../../routes");
const getDistributorImportReport = (client) => async (params) => {
    const response = await client
        .get(routes_1.ENDPOINTS.GET_ONE_DISTRIBUTOR_IMPORT_REPORT.applyParams(params))
        .catch((error) => {
        if (error instanceof axios_client_1.HttpError) {
            if (error.status === 422) {
                return { data: null };
            }
        }
        throw error;
    });
    return response.data;
};
exports.getDistributorImportReport = getDistributorImportReport;
